import { X } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";

import ContentContainer from "./ContentContainer";

import type { ReactNode } from "react";

export default function Sidebar({
  isOpen,
  onClose,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}) {
  if (isOpen) {
    return (
      <ContentContainer className="max-w-[352px] shrink-0 flex-col relative w-full overflow-y-auto scrollbar-thin">
        <Button
          className="absolute right-4 top-4"
          size="xs"
          variant="ghost-black"
          aria-label="close"
          onClick={onClose}
          intent="iconOnly"
        >
          <X />
        </Button>
        {children}
      </ContentContainer>
    );
  }
}
